import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\UnlinkPaymentController::__invoke
* @see app/Http/Controllers/Invoice/UnlinkPaymentController.php
* @route '/api/invoicing/{invoice}/payment/{payment}/unlink'
*/
const UnlinkPaymentController = (args: { invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UnlinkPaymentController.url(args, options),
    method: 'post',
})

UnlinkPaymentController.definition = {
    methods: ["post"],
    url: '/api/invoicing/{invoice}/payment/{payment}/unlink',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Invoice\UnlinkPaymentController::__invoke
* @see app/Http/Controllers/Invoice/UnlinkPaymentController.php
* @route '/api/invoicing/{invoice}/payment/{payment}/unlink'
*/
UnlinkPaymentController.url = (args: { invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
            payment: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
        payment: typeof args.payment === 'object'
        ? args.payment.id
        : args.payment,
    }

    return UnlinkPaymentController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace('{payment}', parsedArgs.payment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\UnlinkPaymentController::__invoke
* @see app/Http/Controllers/Invoice/UnlinkPaymentController.php
* @route '/api/invoicing/{invoice}/payment/{payment}/unlink'
*/
UnlinkPaymentController.post = (args: { invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, payment: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UnlinkPaymentController.url(args, options),
    method: 'post',
})

export default UnlinkPaymentController